import {topics as allTopics} from '@/modules/noutati/index.js';
import { subscribe, unsubscribe } from '@/plugins/notifications.js';

const TOPICS_STORAGE_KEY = 'notifications.topics';

const loadTopics = () => {
  const data = localStorage.getItem(TOPICS_STORAGE_KEY);
  if (data === null) {
    return [];
  }

  let topics;
  try {
    topics = JSON.parse(data);
  } catch (e) {
    return [];
  }

  if (!Array.isArray(topics)) {
    return [];
  }

  return topics.filter(topic => allTopics.hasOwnProperty(topic));
};

const saveTopics = topics => localStorage.setItem(TOPICS_STORAGE_KEY, JSON.stringify(topics.filter(topic => allTopics.hasOwnProperty(topic))));

const wait = duration => (...args) => new Promise(resolve => setTimeout(() => resolve(...args), duration));

const wait700 = wait(700);

export default {
  namespaced: true,
  state: {
    loading: false,
    allTopics,
    topics: loadTopics(),
    token: null,
    error: null
  },
  // getters: {},
  mutations: {
    startLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setTokenSent: (state, sent = true) => {
      state.sent = !!sent;
    },
    setError: (state, error) => {
      state.error = error;
    },
    setToken: (state, token) => {
      state.token = token;
    },
    setTopics: (state, topics) => {
      if (!topics.every(topic => allTopics.hasOwnProperty(topic))) {
        throw new Error('Unknown topic.');
      }

      state.topics = topics;
    }
  },
  actions: {
    subscribeTopic: ({commit, state}, topicAdded) => {
      if (state.loading) {
        throw new Error('An error occurred, try again...');
      }

      const oldTopics = state.topics.slice();
      commit('startLoading');
      commit('setTopics', [...oldTopics, topicAdded]);

      return subscribe(topicAdded)
        .then(() => saveTopics(state.topics))
        .then(wait700)
        .catch(e => {
          commit('setTopics', oldTopics);
          commit('setError', e)
        })
        .finally(() => commit('stopLoading'));
    },
    unsubscribeTopic: async ({commit, state}, topicRemoved) => {
      if (state.loading) {
        throw new Error('An error occurred, try again...');
      }

      const oldTopics = state.topics.slice();
      commit('startLoading');
      commit('setTopics', state.topics.filter(topic => topic !== topicRemoved));

      return unsubscribe(topicRemoved)
        .then(() => saveTopics(state.topics))
        .then(wait700)
        .catch(e => {
          commit('setTopics', oldTopics);
          commit('setError', e)
        })
        .finally(() => commit('stopLoading'));
    }
  }
};
